import { Select } from "@mantine/core";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n/config";
import { useMemo } from "react";
import { IconCoins } from "@tabler/icons-react";


interface Props {
    value: string | null | undefined;
    onChange: (value: string | null) => void;
    label?: string;
    placeholder?: string;
    clearable?: boolean;
    className?: string;
    disabled?: boolean;
    size?: 'xs' | 'sm' | 'md' | 'lg';
}


export default function CurrencySelector({
    value,
    onChange,
    label,
    placeholder,
    clearable,
    className,
    disabled,
    size = 'sm',
}: Props) {
    const { t } = useTranslation();

    const data = useMemo(() => {
        return Object.keys((i18n.t('currencies', { returnObjects: true }) as any) || {}).map(code => ({
            value: code,
            label: `${code} - ${t(`currencies.${code}`)}`
        }));
    }, []);

    return (
        <div className={className || "w-60"}>
            <Select
                size={size}
                leftSection={<IconCoins size={16} stroke={1} />}
                label={label}
                placeholder={placeholder}
                className="w-full"
                data={data}
                value={value || null}
                onChange={onChange}
                searchable
                clearable={clearable}
                disabled={disabled}
            />
        </div>
    );
}